export const FETCH_USER = "fetch_user";
export const LOADING_START = "loading_start";
export const LOADING_END = "loading_end";

export const FETCH_CUSTOMER = "fetch_customer";
export const CREATE_CUSTOMER = "create_customer";
export const CREATE_CUSTOMER_SUCCESS = "create_customer_success";
export const GET_CUSTOMER = "get_customer";
export const DELETE_CUSTOMER = "delete_customer";
export const EDITED_CUSTOMER = "edited_customer";
export const EDIT_CUSTOMER_CONTACT = "edit_customer_contact";
export const CREATE_CUSTOMER_CONTACT = "create_customer_contact";


export const GET_CUSTOMER_CONTACTS = "get_customer_contacts";

export const LOGIN_USER = "login_user";
export const LOGOUT_USER = "logout_user";
export const FORGOT_PASSWORD = "forgot_password";



export const ERROR = "error";
export const START_LOADING = "start_loading";
export const STOP_LOADING = "stop_loading";
export const SET_LOGIN_DATA = "set_login_data";

export const LOGIN_SERVER_ERROR = "login_server_error";

export const SET_LOGIN_ERRORS = "set_login_errors";

export const ROUTE_CHANGE = 'route_change';

export const FIRST_LOGIN_CHANGE = "first_login_change";

export const FILTER_CUSTOMER_CONTACTS = "filter_customer_contacts";